class MegaMenu {
    constructor() {
        this.trigger = document.getElementById('dropdownSolutions');
        this.menu = document.getElementById('menuSolutions');

        if (!this.trigger || !this.menu) return;

        this.navbar = this.trigger.closest('.navbar');
        if (!this.navbar) return;

        this.resizeTimer = null;

        this.init();
    }

    applyOffset() {
        const navbarRect = this.navbar.getBoundingClientRect();
        const triggerRect = this.trigger.getBoundingClientRect();
        const width = Math.round(navbarRect.right - triggerRect.left);

        this.navbar.style.setProperty('--mega-menu-width', width + 'px');
    }

    init() {
        this.trigger.addEventListener('show.bs.dropdown', () => {
            if (window.innerWidth >= 768) {
                this.applyOffset();
            }
        });

        window.addEventListener('resize', () => {
            if (!this.menu.classList.contains('show')) return;
            if (window.innerWidth < 768) return;

            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.applyOffset(), 100);
        }, { passive: true });
    }
}

// Instanciation
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { window.megaMenu = new MegaMenu() });
} else {
    window.megaMenu = new MegaMenu();
}